import { setItem } from 'storage';
import { SET_COLUMN } from 'store/key';
import { produce } from 'utility/general';

export const defaultPostApprovalColumn = [
    {
        key: 'pending',
    },
    {
        key: 'subNo',
    },
    {
        key: 'p1scientificTitle',
    },
    {
        key: 'updateDtm',
    },
    {
        key: 'documentType',
    },
    {
        key: 'statusId',
    },
    {
        key: 'expiryDate',
    },
    {
        key: 'action',
    },
];

export const defaultApplicationColumn = [
    {
        key: 'subTable',
    },
    {
        key: 'refNo',
    },
    {
        key: 'pending',
    },
    {
        key: 'appNo',
    },
    {
        key: 'subNo',
    },
    {
        key: 'updateDtm',
    },
    {
        key: 'p1scientificTitle',
    },
    {
        key: 'coordinator',
    },
    {
        key: 'siteResponseList',
    },
    {
        key: 'statusId',
    },
    {
        key: 'action',
    },
    {
        key: 'updateBy',
    },
    {
        key: 'expiryDate',
    },
];

const initialState = { application: defaultApplicationColumn, postApproval: defaultPostApprovalColumn };
export const APPLICATION_COLUMN = 'application_column_2';
export const POST_APPROVAL_COLUMN = 'post_approval_column_3';

const reducer = (state = initialState, action) => {
    switch (action.type) {
        case SET_COLUMN:
            const newState = produce(state, (draft) => {
                Object.entries(action.payload).forEach(([key, value]) => {
                    draft[key] = action.payload[key];
                });
            });
            return newState;
        default:
            return state;
    }
};

export const updateApplicationColumn = (data) => {
    setItem(APPLICATION_COLUMN, data);
    return {
        type: SET_COLUMN,
        payload: { application: data },
    };
};

export const updatePostApprovalColumn = (data) => {
    setItem(POST_APPROVAL_COLUMN, data);
    return {
        type: SET_COLUMN,
        payload: { postApproval: data },
    };
};

export default reducer;
